import { createContext } from 'react';
import { IConversation } from './provider';

const ConversationContext = createContext<IConversation>({} as IConversation);

export default ConversationContext;
